export const imageAssets = {
    ariyaLogo: require('../image/ariya-logo.png'),
    backgroundImage: require('../image/background-image.jpg'),
    ariya:require('../image/ariya-plain.png')
};

export const iconAssets = {
    download: require('../icon/download.png'),
    user: require('../icon/user.png'),
    downArrow: require('../icon/down-arrow.png'),
    add: require('../icon/add.png'),
    phone: require('../icon/phone.png'),
    email: require('../icon/email.png'),
    web: require('../icon/web.png'),
    delete: require('../icon/delete.png'),
    refresh: require('../icon/refresh.png'),
    extend: require('../icon/extend.png'),
    group: require('../icon/group.png'),
    message: require('../icon/message.png'),
    subject: require('../icon/subject.png'),
    slash: require('../icon/slash.png'),
    reset: require('../icon/reset.png'),
    send: require('../icon/send.png'),
    logout: require('../icon/logout.png'),
    search: require('../icon/search.png'),
    chatUser :require('../icon/chatUser.png'),
    bot: require('../icon/bot.png')
};
